import axios from "axios";

const baseURL = "https://api.hospitality.imgate.co.kr";
const apiKey = "ZDFmNDZkNmIwODI3Zjc3ZjljZWUwYjZjZmNiODJiOWNjMGVjMjcwZTozZjg4ZDFjYjk2ZjU0OWUwNDI3MGZhODkyMTljODM3OThlZjE2NmNi";
const hotelId = process.env.REACT_APP_IMGATE_BACKEND_HOTELID;

const request = axios.create({
  baseURL,
});

const headers = (header) => {
  return {
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
      Charset: "utf-8",
      ...(header && header),
    },
  };
};

export const getQRcode = ({ start_at, end_at }) => {
  return request
    .post(
      `/v2/domains/hotels/${hotelId}/guest/qrcodes`,
      {
        start_at,
        end_at,
        commonroom_bits: [0, 1],
      },
      headers({})
    )
    .then((res) => res.data);
};
